'use strict';

var React = require('react');

var SvgFeaturedContentMajor = function SvgFeaturedContentMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m16.56 4.56-4.12-4.12a1.5 1.5 0 0 0-1.06-.44h-6.88a1.5 1.5 0 0 0-1.5 1.5v17a1.5 1.5 0 0 0 1.5 1.5h10.5a2 2 0 0 0 2-2v-12.38a1.5 1.5 0 0 0-.44-1.06zm-8.16 2.44c-1 0-1.9.9-1.9 2 0 2.2 1.3 3.9 3.5 5 2.2-1.1 3.5-2.8 3.5-4.9v-.2c0-1-.9-1.9-1.9-1.9-1 0-1.6 1.167-1.6 1.167s-.6-1.167-1.6-1.167z"
  }));
};

exports.SvgFeaturedContentMajor = SvgFeaturedContentMajor;
